import Api from "./Api";
import Csrf from "./Csrf";

export default {
  async update(id, form) {
    await Csrf.getCookie();

    return Api.patch("/workflows/" + id, form);
  },

  async index() {
    await Csrf.getCookie();

    return Api.get("/workflows");
  },

  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/workflows/" + id);
  },

  async add(form) {
    await Csrf.getCookie();

    return Api.post("/workflows", form);
  },

  async show(id) {
    await Csrf.getCookie();

    return Api.get("/workflows/" + id);
  },

  async forceShow(id) {
    await Csrf.getCookie();

    return Api.get("/workflows/" + id + "/true");
  },

  async copy(id) {
    await Csrf.getCookie();

    return Api.get("/workflows/" + id + "/copy");
  },
};
